import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';

class PlutoApplicationContainer extends PureComponent {
  componentDidMount() {
    this.props.setAppInfo(this.props.appName, this.props.appVersion);
    this.props.appLaunch();
  }

  render() {
    const { store, persistor, children } = this.props;
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          {children}
        </PersistGate>
      </Provider>
    );
  }
}

PlutoApplicationContainer.propTypes = {
  store: PropTypes.any.isRequired,
  persistor: PropTypes.any.isRequired,
  children: PropTypes.node.isRequired,
  appLaunch: PropTypes.func.isRequired,
  setAppInfo: PropTypes.func.isRequired,
  appName: PropTypes.string.isRequired,
  appVersion: PropTypes.string.isRequired,
};

export { PlutoApplicationContainer };
